// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Vue 3 setup
import { createApp } from 'vue'
import App from './components/App.vue'

// Mount Vue app when Turbo loads the page
document.addEventListener('turbo:load', () => {
  const appElement = document.getElementById('vue-app')
  if (appElement) {
    const app = createApp(App)
    app.mount(appElement)
  }
})
